import { DENSITY_LABELS, DENSITY_OPTIONS, type Density } from "../density";

interface Props {
  value: Density;
  onChange: (next: Density) => void;
}

export function DensityPicker({ value, onChange }: Props) {
  return (
    <div
      role="radiogroup"
      aria-label="row density"
      className="inline-flex rounded-md border border-zinc-700 overflow-hidden text-xs font-mono"
    >
      {DENSITY_OPTIONS.map((opt) => {
        const active = opt === value;
        return (
          <button
            key={opt}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(opt)}
            className={
              active
                ? "px-2.5 py-1 bg-zinc-700 text-zinc-100"
                : "px-2.5 py-1 bg-zinc-900 text-zinc-400 hover:bg-zinc-800 hover:text-zinc-200"
            }
          >
            {DENSITY_LABELS[opt]}
          </button>
        );
      })}
    </div>
  );
}
